import {atom} from "jotai";

export const deleteWorkLogStateAtom = atom(false);
export const deleteWorkLogDetailAtom = atom({});